const displayTime = 2500;
const errorText = "Errore nel recupero delle informazioni";
const infoText = undefined;

export default { displayTime, errorText, infoText };

